"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IImprovePerformance = void 0;
var IImprovePerformance;
(function (IImprovePerformance) {
    IImprovePerformance["Other"] = "other";
    IImprovePerformance["Strength"] = "strength";
    IImprovePerformance["Flexibility"] = "flexibility";
    IImprovePerformance["Endurance"] = "endurance";
})(IImprovePerformance || (exports.IImprovePerformance = IImprovePerformance = {}));
//# sourceMappingURL=improve-performance.js.map